import { Button, CircularProgress, Grid } from '@material-ui/core';
import React from 'react';
import { useNotify } from '../../../hooks/useNotify';
import { doSwaggerCall, useSwaggerClient } from '../../../hooks/useSwaggerClient';
import PriceItemTable from '../../../components/PriceItemTable';
import AdminHeader from '../../../components/atom/AdminHeader';

const SystemFeeEditPage = () => {
    const { notifyError, notifySuccess } = useNotify();
    const [items, loading, error, setItems] = useSwaggerClient('system', 'getSystemPriceItems', {});

    return (
        <Grid container className="bg-white client-table page" alignItems="center" spacing={2}>
            <AdminHeader title="System fees" />
            {loading ? (
                <CircularProgress />
            ) : (
                <Grid container item xs={12} spacing={2}>
                    {!error ? (
                        <>
                            <PriceItemTable title="Fees" items={items} setItems={setItems} />
                            <Grid item xs={12}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        doSwaggerCall('system', 'updateSystemPriceItems', {
                                            updatedPriceItems: items.map(item => ({
                                                ...item,
                                                net_usd: parseFloat(item.net_usd),
                                                net_percentage: parseFloat(item.net_percentage)
                                            }))
                                        })
                                            .then(() =>
                                                notifySuccess('Successfully updated price items')
                                            )
                                            .catch(err => notifyError(err.response.body.message));
                                    }}
                                >
                                    Save
                                </Button>
                            </Grid>
                        </>
                    ) : (
                        <h4>Could not load price items</h4>
                    )}
                </Grid>
            )}
        </Grid>
    );
};

export default SystemFeeEditPage;
